import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, DataListItem } from '@node-space/ui-components'
import { useProfileContext } from 'hooks/context/useProfileContext'

export const PersonalDetails = () => {
  const { t } = useTranslation()

  const { profile } = useProfileContext() || {}
  const { firstName, lastName, country, emailAddress } = profile || {}

  return (
    <Box flexCol gapY={24}>
      <h3 className="text-h3 text-foreground-prominent">{t('account.personalDetails')}</h3>
      <Box flexCol>
        <DataListItem
          id="first-name"
          testId="first-name"
          title={t('firstName')}
          body={firstName || '-'}
          layout="vertical"
        />
        <DataListItem
          id="last-name"
          testId="last-name"
          title={t('lastName')}
          body={lastName || '-'}
          layout="vertical"
        />
        <DataListItem
          id="country"
          testId="country"
          title={t('country')}
          body={country?.name || '-'}
          layout="vertical"
        />
        <DataListItem
          id="email-address"
          testId="email-address"
          title={t('emailAddress')}
          body={emailAddress || '-'}
          layout="vertical"
        />
      </Box>
    </Box>
  )
}
